import { useInfiniteQuery } from "@tanstack/react-query";
import { ApiGetUserDynamicRewardDailyRecords } from "@/api";
import type { GetUserDynamicRewardDailyRecordsResponse } from "@/api/types";

const PAGE_SIZE = 100;

export function useUserDynamicRewardDailyRecords(coinContract?: string) {
  return useInfiniteQuery({
    queryKey: ["userDynamicRewardDailyRecords", coinContract ?? ""],
    queryFn: async ({
      pageParam,
    }): Promise<GetUserDynamicRewardDailyRecordsResponse> => {
      const res = await ApiGetUserDynamicRewardDailyRecords({
        page: pageParam,
        pageSize: PAGE_SIZE,
        coinContract,
      });
      console.log("useUserDynamicRewardDailyRecords", res.data);
      return res.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const fetched = allPages.reduce(
        (sum, page) => sum + (page.records?.length ?? 0),
        0
      );
      if (fetched >= (lastPage.total ?? 0)) return undefined;
      return allPages.length + 1;
    },
  });
}
